import React from "react";

const H3Icon = props => (
  <svg width={17} height={10} viewBox="0 0 17 10" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.423 9.826H6.415V5.747H1.993v4.079H0V.146h1.993v3.802h4.422V.145h2.008v9.68zm4.885.174c-1.713 0-3.004-.682-3.692-1.553l1.053-1.379c.632.697 1.656 1.103 2.569 1.103 1.137 0 1.769-.508 1.769-1.233 0-.77-.576-1.118-1.881-1.118-.394 0-1.025.015-1.166.03V3.99c.169.015.815.015 1.166.015 1.038 0 1.74-.32 1.74-1.03 0-.77-.772-1.147-1.74-1.147-.913 0-1.727.348-2.387 1.001l-.997-1.292C10.5.653 11.68 0 13.322 0c2.19 0 3.538 1.016 3.538 2.627 0 1.22-1.011 2.017-2.05 2.206.955.102 2.19.87 2.19 2.322C17 8.825 15.554 10 13.308 10z"
    />
  </svg>
);

export default H3Icon;
